<app-patient-info [heading]="Item"></app-patient-info>

<div [hidden]="activatedRoute.children.length > 0">
    <div class="card mb-2">
        <div class="col-12" style="display: flex">
            <div class="col-6 md:col-6">
                <p-multiSelect [options]="categories"
                               [(ngModel)]="selectedCategories"
                               optionLabel="label"
                               optionValue="value"
                               [showToggleAll]="true"
                               selectedItemsLabel="{0} clinical data selected"
                               placeholder="Choose clinical data"
                               [style]="{ minWidth: '100%' }"
                               (onChange)="toggleCategorySelection()">
                </p-multiSelect>
            </div>
            <div class="col-3 md:col-3">
                <button pButton
                        type="button"
                        icon="pi pi-cloud"
                        label="Export"
                        (click)="askForComment()"
                        class="p-button-plain blueGradient"
                        [class.disabled]="selectedCategories.length == 0"></button>&nbsp;
                <button pButton [class.disabled]="isDisableDocument"
                        type="button"
                        icon="pi pi-file"
                        label="Export CCDA"
                        (click)="ccdaDocuments()"
                        *ngIf="showExportCCDA"
                        class="p-button-plain blueGradient"></button>
            </div>



        </div>
        <div class="grid">
            <div class="col-3 md:col-3 lg:col-3 xl:col-3" [class.disabled]="isDisableDocument">
                <span class="p-float-label">
                    <p-calendar [(ngModel)]="datefrom"
                                [yearNavigator]="true"
                                yearRange="{{ yearRangeForDatePicker }}"
                                [readonlyInput]="true"
                                showButtonBar="true"
                                appendTo="body"></p-calendar>
                    <label for="float-input">Date From</label>
                </span>
            </div>

            <div class="col-3 md:col-3 lg:col-3 xl:col-3" [class.disabled]="isDisableDocument">
                <span class="p-float-label">
                    <p-calendar [(ngModel)]="dateto"
                                [yearNavigator]="true"
                                yearRange="{{ yearRangeForDatePicker }}"
                                [readonlyInput]="true"
                                showButtonBar="true"
                                appendTo="body"></p-calendar>
                    <label for="float-input">Date To</label>
                </span>
            </div>

            <div class="col-4 md:col-4" [class.disabled]="isDisableDocument">
                <button pButton
                        type="button"
                        icon="pi pi-search"
                        label="Filter"
                        (click)="getfiltered()"
                        class="p-button-plain"></button>&nbsp;
                <button pButton
                        type="button"
                        icon="pi pi-times-circle"
                        label="Clear"
                        (click)="clearfilters()"
                        class="p-button-plain GreyButton"></button>&nbsp;
            </div>
        </div>




    </div>



    <div class="col-12">

        <p-table #dt
                 *ngIf="emrDocumentsList"
                 [responsive]="true"
                 [columns]="cols"
                 [value]="emrDocumentsList"
                 [(selection)]="selectedItems"
                 [autoLayout]="true"
                 [rows]="rowsEmrDocs"
                 [paginator]="showRecordsEmrDocs"
                 [(first)]="first">
            <ng-template pTemplate="header" let-columns>
                <tr *ngIf="showRecordsEmrDocs == true">
                    <th [class.disabled]="isDisableDocument">
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <th *ngFor="let col of columns" [pSortableColumn]="col.field" [class.disabled]="isDisableDocument">
                        <span class="column-title">{{ col.header }}</span>
                        <p-sortIcon [field]="col.field"
                                    ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                    </th>
                    <th [class.disabled]="isDisableDocument">View</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body"
                         let-rowData
                         let-columns="columns"
                         let-i="rowIndex">
                <tr [pSelectableRow]="rowData">
                    <td [class.disabled]="isDisableDocument">
                        <p-tableCheckbox [value]="rowData"> </p-tableCheckbox>
                    </td>

                    <td *ngFor="let col of columns">

                        <div *ngIf="
                col.header == 'Visit Date';
                then nested_object_content;
                else normal_content
              "></div>
                        <ng-template #nested_object_content>
                            <!--<span class="column-title">{{col.header}}</span>-->
                            {{ formatdatetime(rowData[col.field], col.header) }}
                        </ng-template>
                        <ng-template #normal_content>
                            <!--<span class="column-title">{{col.header}}</span>-->
                            {{ rowData[col.field] }}
                        </ng-template>
                    </td>
                    <td>
                        <button pButton
                                type="button"
                                icon="pi pi-book"
                                class="ui-button-success"
                                (click)="viewDocUnMerged(rowData)"
                                style="font-size: 0.7em"></button>
                    </td>
                </tr>
            </ng-template>

            <ng-template #emptyTemplate>
                <div class="w-12 bg-white">
                    <div class="" style="text-align: center">
                        <img _ngcontent-ng-c683320295=""
                             class="profile-image"
                             style="border-radius: 50%; width: 10rem; padding-top: 1rem"
                             src="assets/imagesNew/table_error.png" />
                    </div>
                    <hr style="margin-bottom: 0.5rem" />
                    <div class=""
                         style="text-align: center; font-size: larger; color: #1d428f">
                        <i>No records found</i>
                    </div>
                </div>
            </ng-template>
        </p-table>
    </div>

    <div class="col-12">
        <p-table *ngIf="localDocumentsList"
                 [responsive]="true"
                 [columns]="localcols"
                 [value]="localDocumentsList"
                 [rows]="rowsLocal"
                 [paginator]="showRecordsLocal">
            <ng-template pTemplate="header" let-columns>
                <tr *ngIf="showRecordsLocal == true">
                    <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                        {{ col.header }}
                        <p-sortIcon [field]="col.field"
                                    ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                    </th>

                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body"
                         let-rowdata
                         let-columns="columns"
                         let-i="rowindex">
                <tr [pSelectableRow]="rowdata" [ngClass]="{'pending':rowdata?.status=='Pending'}">

                    <td *ngFor="let col of columns">


                        @if (col.field==='status')
                        {
                        @if (rowdata['status']==='Completed')
                        {
                        @if(rowdata['exportCounter'] < rowdata['sourceCounter'])
                        {
                        Completed With Errors
                        }
                        @else
                        {
                        {{rowdata[col.field]}}
                        {{getstartusWithErro(rowdata['clinicalDataExportStatus'])}}

                        }
                        }
                        @else if (rowdata[col.field]==='Pending')
                        {
                        In Progress
                        }
                        @else
                        {
                        {{rowdata[col.field]}}
                        }

                        }
                        @else if (col.field !== 'exportDetails') {
                        {{ formatdatetime(rowdata[col.field], col.header) }}

                        }
                        @else
                        {
                        @if(rowdata['exportType'] != 'CCDA')
                        {
                        <span (click)="viewClinicalConversionDetails((rowdata))" title="Click to View Details" style="color:blue !important">
                            @if(rowdata['clinicalDataExportStatus'][rowdata['clinicalDataExportStatus'].length-1]?.ClinicalDataType=='Document & Images')
                            {
                            @if (rowdata['status']==='Completed')
                            {
                            Clinical Data Exported
                            }
                            @else {

                            {{rowdata['clinicalDataExportStatus'][rowdata['clinicalDataExportStatus'].length-1]?.ClinicalDataType}}

                            {{messageMappings[rowdata['clinicalDataExportStatus'][rowdata['clinicalDataExportStatus']?.length-1]?.ClinicalDataStatus]}}<br />
                            Converted {{rowdata['exportCounter']}} out of {{rowdata['sourceCounter']}}
                            }
                            }

                            @else
                            {
                            @if (rowdata['status']==='Completed')
                            {
                            Clinical Data Exported
                            }
                            @else
                            {
                            {{rowdata['clinicalDataExportStatus'][rowdata['clinicalDataExportStatus']?.length-1]?.ClinicalDataType}}

                            {{messageMappings[rowdata['clinicalDataExportStatus'][rowdata['clinicalDataExportStatus']?.length-1]?.ClinicalDataStatus]}}
                            }

                            }
                        </span>
                        }
                        @else
                        {
                        @if(rowdata['exportType'] != 'CCDA')
                        {
                        <span>
                            @if (rowdata['status']==='Completed')
                            {
                            CCDA Data Exported
                            }
                        </span>
                        }
                        }
                        <span *ngIf="rowdata['exportType'] == 'CCDA'" [attr.title]="rowdata['exportCounter'] === rowdata['sourceCounter']? '!!Success!!': '!!Failure!! ' + rowdata['fileConversionInfo']"
                              tooltipPosition="top">
                            <span>
                                CCDA Exported
                            </span>

                        </span>
                        }

                    </td>

                    <td class="col-12 md:col-2" style="text-align: center !important">

                        <button pButton *ngIf="rowdata?.comment"
                                type="button"
                                icon="pi pi-eye"
                                pTooltip="View Comment"
                                class="p-button-plain ml-1"
                                style="font-size: 0.7em"
                                (click)="showCommentDialog(rowdata)"></button>&nbsp;

                        <ng-container *ngIf="rowdata['exportType'] !== 'CCDA';else documentType">
                            <button *ngIf="rowdata?.status=='Completed'"
                                    pButton
                                    type="button"
                                    icon="pi pi-book"
                                    pTooltip="View Doc"
                                    class="p-button-plain"
                                    style="font-size: 0.7em"
                                    (click)="viewDoc(rowdata)"></button>
                        </ng-container>


                        <ng-template #documentType>
                            <button pButton *ngIf="rowdata?.status=='Completed'"
                                    type="button"
                                    icon="pi pi-download"
                                    class="p-button-plain"
                                    style="font-size: 0.7em"
                                    (click)="viewDoc(rowdata)"></button>

                        </ng-template>
                    </td>
                </tr>
            </ng-template>

            <ng-template #emptyTemplate>
                <div class="w-12 bg-white">
                    <div class="" style="text-align: center">
                        <img _ngcontent-ng-c683320295=""
                             class="profile-image"
                             style="border-radius: 50%; width: 10rem; padding-top: 1rem"
                             src="assets/imagesNew/table_error.png" />
                    </div>
                    <hr style="margin-bottom: 0.5rem" />
                    <div class=""
                         style="text-align: center; font-size: larger; color: #1d428f">
                        <i>No records found</i>
                    </div>
                </div>
            </ng-template>
        </p-table>
    </div>
</div>
<div [hidden]="activatedRoute.children.length === 0">
    <p-button label="Back" (click)="back()"></p-button>

    <router-outlet></router-outlet>
</div>




<p-dialog header="Enter Comment" [modal]="true" [(visible)]="commentDialog" [style]="{ width: '25rem' }">
    <p-floatLabel>
        <textarea id="float-input"
                  rows="5" cols="30"
                  style="width:100%"
                  [formControl]="comment"
                  pInputTextarea appAddFormAttributes>
    </textarea>
        <label for="float-input">Comment</label>
    </p-floatLabel>
    <div class="flex justify-content-end gap-2">
        <p-button label="Export" severity="secondary" (click)="Restoredocuments()" />
    </div>
</p-dialog>


<p-dialog header="Enter Comment" [modal]="true" [(visible)]="commentDialog_ccda" [style]="{ width: '25rem' }">
    <p-floatLabel>
        <textarea id="float-input"
                  rows="5" cols="30"
                  style="width:100%"
                  [formControl]="comment"
                  pInputTextarea appAddFormAttributes>
    </textarea>
        <label for="float-input">Comment</label>
    </p-floatLabel>
    <div class="flex justify-content-end gap-2">
        <p-button label="Export CCDA" severity="secondary" (click)="Restoredocuments_CCDA()" />
    </div>
</p-dialog>

<p-dialog header="Comment" [modal]="true" [(visible)]="showComment" [style]="{ width: '45rem' }">

    <span>
        {{commentText}}
    </span>
</p-dialog>


<p-dialog [(visible)]="displaypopupDetails" [draggable]="true" [modal]="true" positionType="absolute"
          [style]="{ width: '25vw' }" [baseZIndex]="10000" [maximizable]="true">
    <p-header>
        Clinical Data
    </p-header>
    <div class="p-fluid" style="padding-left: 10px">
        <div class="mb-2">
            <p-table class="tableDashboard"
                     *ngIf="documentExportStatus?.clinicalDataExportStatus"
                     [columns]="['ClinicalDataType', 'Status']"
                     [value]="documentExportStatus?.clinicalDataExportStatus"
                     selectionMode="single"
                     [resetPageOnSort]="false"
                     [lazy]="false"
                     stripedRows>

                [resizableColumns]="true"
                [paginator]="false">
                <ng-template *ngIf="ClinicalDataType" pTemplate="header">
                    <tr>
                        <th>Clinical DataType</th>
                        <th>Status</th>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-rowData>
                    <tr [pSelectableRow]="rowData">
                        @if ( rowData.ClinicalDataType=="Document & Images") {

                        <td [pTooltip]="getFailedFiles()?.length>0? failedFiles:''" tooltipPosition="bottom" [autoHide]="false">

                            <b>{{ rowData.ClinicalDataType }}(Converted {{documentExportStatus.exportCounter}} out of {{documentExportStatus.sourceCounter}})</b>
                        </td>
                        }

                        @else {
                        <td>
                            {{ rowData.ClinicalDataType }}
                        </td>
                        }

                        <td>




                            <span [ngClass]="getStatusBadgeClass(rowData.ClinicalDataStatus)">
                                {{ getStatusText(rowData.ClinicalDataStatus) }}
                            </span>


                        </td>
                    </tr>
                </ng-template>
            </p-table>

        </div>
    </div>

    <hr />

    <p-footer style="display: flex; justify-content: center">
        <button pButton type="button" icon="pi pi-times-circle" (click)="displaypopupDetails = false"
                label="Cancel" class="ui-button-secondary"></button>
    </p-footer>
</p-dialog>


<ng-template #failedFiles>

    <p-table [value]="getFailedFiles()" *ngIf="getFailedFiles()?.length>0">
        <ng-template pTemplate="header">
            <tr>
                <th>Failed Conversions</th>
                <th>Visit Date</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
            <tr [pSelectableRow]="rowData">
                <td>
                    {{rowData.description}}
                </td>
                <td>
                    {{rowData.visitDate | date}}
                </td>
            </tr>
        </ng-template>
      
    </p-table>
</ng-template>



